module.exports = __webpack_public_path__ + "static/img/Tela do whats.889b5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela do whats.png
// module id = IIn1
// module chunks = 0